<template lang="pug">
  v-toolbar.white.py-4.mb-4
    v-layout.justify-center.align-center.py-4
      v-flex.xs9
        v-layout.align-end
          img.py-2.pl-1.pr-3(src="@/assets/logo.png")
          .account-banner.font-weight-medium.white--text.black.px-2.mb-2 MON COMPTE
      v-flex.xs3
        .text-xs-right
          v-menu(offset-y v-if="logged")
            v-btn.white(slot="activator" depressed large) {{ logged }}
              v-icon.pl-2 settings
            v-list
              v-list-tile(@click="disconnect") Déconnexion
          v-btn.white(depressed large v-else :to="{ name: 'login' }") Me connecter
            v-icon.pl-2 account_circle
</template>

<script>
export default {
  data() {
    return {
      apiData: {},
    };
  },
  methods: {
    disconnect() {
      const redirectUri = window.location.origin;
      window.location.href = `${window.location.origin}/api/v2/tmaps/logout?redirect_uri=${redirectUri}`;
    },
  },
  computed: {
    logged() {
      return this.$store.state.user.logged.login;
    },
  },
};
</script>

<style lang="scss">
  .v-menu__content {
    z-index: 1004!important;
  }
  .account-banner {
    font-size: 16px;
  }
</style>
